export const systemType = 4;